<app-main *ngIf="shouldLoadMainComponent"></app-main>
<router-outlet name="auth"></router-outlet>
